export default __webpack_public_path__ + "static/media/pinGreen.9a10c25b.svg";